<template>
<div class="zoomSlider">
  <input type="range" v-model="size" :min=min :max=max :step=step>
  <button class="shrink" @click="()=> size= Math.max(size-step, min) ">축소</button>
  <button class="expand" @click="()=> size= Math.min(size+step, max) ">확대</button>
  <!-- <button class="fullScreen" @click="fullScreen">최대화면</button> -->
</div>
</template>

<script>
export default {
  props: {
    init: { type: Number, default() {return 1.6} },
    min: { type: Number, default() {return 0.2} },
    max: { type: Number, default() {return 3} },
    step: { type: Number, default() {return 0.2} },
  },
  data() {
    return{
      screenStatus: false,
      size: this.init,
    }
  },
  watch: {
    size(value){
      this.sizeChange(value);
    },
    init (value) {
      this.size = value;
    }
  },
  methods: {
    fullScreen(event) {
      this.screenStatus = !this.screenStatus;
      this.$emit('full-screen', {status: this.screenStatus});
    },
    sizeChange(value) {
      this.$emit('change', value);
    }
  }
}

</script>
<style lang="scss" scoped>
.zoomSlider {
  display: grid; align-items: center; justify-content: center;
  grid-template:
    'shrink range expand fullScreen' auto /
    auto 1fr auto auto
  ;
  background: #fff;
  border-radius: 5px;
  // border: 1px solid #ccc;
  height: 32px;
  gap: 10px;
  padding-left: 10px;


  input[type='range'] {
    grid-area: range;
    -webkit-appearance: none;
    appearance: none;
    background-color: #ccc;
    width: 140px; height: 6px;
    cursor: pointer;
    &::-webkit-slider-thumb {
      appearance: none;
      width: 14px; height: 14px;
      border-radius: 50%;
      background-color: #333;
    }
  }
  button {
    width: 24px; height: 24px;
    font-size: 0;
    &.shrink {grid-area: shrink;
      background: url('../../assets/icons/icon-minus.svg') center no-repeat;
    }
    &.expand {grid-area: expand}
    background: url('../../assets/icons/icon-plus.svg') center no-repeat;
  }
  .fullScreen {
    grid-area: fullScreen;
    width: 20px; height: var( --default-gap );
    background: url('../../assets/icons/icon-fullscreen.svg') center no-repeat;
    font-size: 0;
  }
}

</style>

